import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingConfig } from './tracking.interface';
import { CustomTrackingEvent, TrackingEventData } from './tracking.model';

export enum QuoraStandardEvents {
  GENERATE_LEAD = 'GenerateLead',
  PURCHASE = 'Purchase',
  ADD_TO_CART = 'AddToCart',
}

@Injectable()
export class QuoraPixelTracking {
  private isEnabled = false;

  constructor(
    private ngZone: NgZone,
    @Inject(TRACKING_CONFIG) private config: TrackingConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (this.config.quoraPixelId && isPlatformBrowser(this.platformId)) {
      this.isEnabled = true;
    }
  }

  trackPageView(): void {
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      window.qp('track', 'ViewContent');
    });
  }

  trackCustomEvent(payload: CustomTrackingEvent & TrackingEventData): void {
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      window.qp('track', payload.quoraEventName);
    });
  }

  private loadTrackingSnippet(): void {
    if (window.qp) {
      return;
    }

    window.qp = function qp() {
      if (window.qp.qp) {
        // eslint-disable-next-line prefer-rest-params, prefer-spread
        window.qp.qp.apply(window.qp, arguments);
      } else {
        // eslint-disable-next-line prefer-rest-params
        window.qp.queue.push(arguments);
      }
    };
    window.qp.queue = [];
    const e = document.createElement('script');
    e.async = true;
    e.src = 'https://a.quora.com/qevents.js';
    const s = document.getElementsByTagName('script')[0];
    (s.parentNode as Node).insertBefore(e, s);
    // TODO: setup tracking if javascript is disabled
    window.qp('init', this.config.quoraPixelId);
  }
}
